/* unplugin-vue-components disabled */import { render } from "./error-table.vue?vue&type=template&id=18b963be&scoped=true"
import script from "./error-table.vue?vue&type=script&lang=js"
export * from "./error-table.vue?vue&type=script&lang=js"

import "./error-table.vue?vue&type=style&index=0&id=18b963be&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/amoeba-logistics-information-system-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b963be"]])

export default __exports__